"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyingStatus = void 0;
var BuyingStatus;
(function (BuyingStatus) {
    BuyingStatus["FailedNotEnoughBalance"] = "failed_not_enough_balance";
    BuyingStatus["FailedPriceChanged"] = "failed_price_changed";
    BuyingStatus["FailedUnlistedOrSoldOut"] = "failed_unlisted_or_soldout";
    BuyingStatus["FailedBuy"] = "failed_buy";
    BuyingStatus["Success"] = "success";
})(BuyingStatus = exports.BuyingStatus || (exports.BuyingStatus = {}));
